<input type="text" id="scriptHelper" class="sr-only">
<div class="main-content" *ngIf="!profile">
  <div class="loader"></div>
</div>

<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
  <p class="app-loading-message">{{loadingMessage}}</p>
</div>
<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            <b>Instale o Selo</b>
          </h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12 col-xs-12">
              <!-- <label> Primeiros passos </label> -->
              <p>
                Para que o selo Quem Transforma apareça no rodapé do seu site, é só seguir o passo a passo disponível no manual de instalação abaixo, copiando o código disponível nesta página e adicionando onde você preferir. Vamos lá?
                <br/>
                <strong>Obs.:</strong> Caso você tenha instalado o selo CompreDoe, ele foi alterado automaticamente para o selo Quem Transforma desde o dia 07/02.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="profile != null">
    <div class="col-md-12" >
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Adicione o Selo</h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Para adicionar, copie o código HTML abaixo onde deseja adicionar o selo. Você pode ajustar o
                  tamanho do selo alterando o <i>width</i> que por padrão é 150px </label>
                <textarea id="scriptArea" name="script"
                  style="width: 100%;height: 120px; padding: 9.5px; margin: 0 0 10px; font-size: 13px; line-height: 1.42857143; color: #333; word-break: break-all; word-wrap: break-word; background-color: #f5f5f5; border: 1px solid #ccc; border-radius: 4px;"
                  readonly>{{script}}</textarea>
                <small style="color:red">
                  Certifique-se de ter o <a href="/#/setup">script do Polen</a> instalado para
                  que o selo apareça corretamente.
                </small>
              </div>

            </div>

          </div>
          <div>
            <button type="button" class="btn btn-info btn-fill" (click)="copyToClipboard()">Copiar</button>
            <button style="display: none;" class="btn btn-warning btn-fill btn-wd" type="button"
              (click)="showTestLive()">Ver Online</button>
            <div style="float: right;">
              Para testar, copie e cole no campo HTML: <a href="https://jsfiddle.net" target="_blank">jsfiddle.net</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-12" *ngIf="!profile.activePayingUser || profile.planSeoName == 'trial'">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title"><b>Adicionando o Selo</b></h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Ops, para ter acesso ao selo CompreDoe você preciso contratar um plano Polen.</label>
                <div class="col-sm-12">
                  <p style="text-align: center;    margin: 30px 0;">
                    <a style="padding: 8px;
                    width: 50%;
                    font-size: 25px;" class="btn btn-success btn-fill" href="/#/profile/plans">Contratar Plano</a>
                    <br>
                    <small>Após a contratação, o link do selo estará disponível em até 24h.</small>
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- <hire-feature *ngIf="!authenticationService.hasFeature('selo-compredoe')" [featureId]="'campanha'" [name]="'Campanha'"
                [description]="'adicionar o selo CompreDoe, entregando mais credibilidade em toda ação ao seu consumidor, '"></hire-feature> -->

  <div class="row">
    <div class="col-md-6" style="display: none;">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            <b>Faça parte do Movimento</b>
            <br><small>Nossa CEO, Renata Chemin tem um recado pra você</small>
          </h4>
        </div>
        <div class="card-content">
          <div class="videoWrapper">
            <iframe width="560" height="349" src="https://www.youtube.com/embed/vjxgQFOQON8" frameborder="0"
              allowfullscreen></iframe>
          </div>
          <!-- <div class="video">
                <div class='embed-container'>
                  <iframe src='https://www.youtube.com/embed/vjxgQFOQON8' frameborder='0' allowfullscreen></iframe>
                </div>
              </div> -->
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            <b>Veja o Manual de Instalação</b>
          </h4>
        </div>
        <div class="card-content">
          <p>
            Acesse o arquivo abaixo para conferir o passo a passo.
          </p>
          <p style="text-align: center;">
            <a target="_blank"
              href="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/downloads/selo-quem-transforma-manual-de-instalacao.pdf">
              <img
                src="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/painel/capa-selo-quem-transforma.png"
                alt="Manual do Movimento CompreDoe" style="width: 21.8vw;" /></a>
            <a style="width: 80%; margin-top: 2vh;;" class="btn btn-success btn-fill btn-wd" target="_blank"
              href="https://storage.googleapis.com/sealpolen-files.polinizador.com.br/downloads/selo-quem-transforma-manual-de-instalacao.pdf">
              Clique aqui para acessar o manual
            </a>
          </p>
          <p>O Selo ainda não aparece ou ficou alguma dúvida?
            <br><b>Nos chame no chat</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
